import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader">
      <img src="/assets/spin-loader.svg" alt="loader" />
    </div>
  );
};

export default Loader;
